import React from 'react'

const HowDoes = () => {
    return (
        <>
            <section className="renvia-service-sec pt-115 pb-80" style={{marginTop:"-180px"}}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7 col-lg-10">
                            {/* Section Title */}
                            <div className="section-title text-center mb-45">
                                <span className="sub-title aos-init aos-animate" data-aos-duration={1000}><img src="assets/images/line1.png" alt="line" />Earth Bond Property<img src="assets/images/line2.png" alt="line" /></span>
                                <h2 className="text-anm" aria-label="Strategic Real Estate Solutions Tailored for You">
                                    How Does It Work
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            {/* Renvia Service Card */}
                            <div className="renvia-service-card style-three mb-40 aos-init" data-aos-duration={1000}>
                                <div className="icon">
                                    <img src="assets/img/Receive The Property.png" alt="icon" style={{ width: "80px", height: "80px" }} />
                                </div>
                                <div className="content">
                                    <h4 className="title"><a to="service-details.html">Choose Any where</a></h4>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            {/* Renvia Service Card */}
                            <div className="renvia-service-card style-three mb-40 aos-init" data-aos-duration={1200}>
                                <div className="icon">
                                    <img src="https://res.cloudinary.com/dnquglkeh/image/upload/v1773640447/Contact_With_Us_gebskb.jpg" alt="icon" style={{ width: "90px", height: "90px" }} />
                                </div>
                                <div className="content">
                                    <h4 className="title"><a to="service-details.html">Contact With Us</a></h4>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            {/* Renvia Service Card */}
                            <div className="renvia-service-card style-three mb-40 aos-init" data-aos-duration={1400}>
                                <div className="icon">
                                    <img src="assets/img/Pay For The Property.jpg" alt="icon" style={{ width: "90px", height: "90px" }} />

                                </div>
                                <div className="content">
                                    <h4 className="title"><a to="service-details.html">Pay For The Property</a></h4>

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            {/* Renvia Service Card */}
                            <div className="renvia-service-card style-three mb-40 aos-init" data-aos-duration={1600}>
                                <div className="icon">
                                    <img src="assets/img/Receive The Property.png" alt="icon" style={{ width: "80px", height: "80px" }} />

                                </div>
                                <div className="content">
                                    <h4 className="title"><a to="service-details.html">Receive The Property</a></h4>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HowDoes